import { useCheckinHandlerResult } from '../../ServiceContext'

export const isErrorRequest = (data, callback) => {
  if (Boolean(data?.error) === true) {
    callback && callback('error')
    throw Error(data)
  }

  return data
}

export const useOnError = notify => {
  const [_handlerResult, setHandlerResult] = useCheckinHandlerResult()

  return err => {
    setHandlerResult && setHandlerResult('error')
    console.log('err', err)
    return notify.error({ title: `Ocorreu Algum erro ao salvar essa nova integração!` })
  }
}
